<div class="fixed w-screen left-1/2 right-1/2 -translate-x-1/2 -translate-y-1/2">
  <section class="row">
    <div class="col-sm-10 offset-sm-1 col-md-10 offset-md-1 offset-lg-2 col-lg-7 col-xl-4 offset-xl-3">
      <ngb-alert *ngIf="errorMsg" [type]="'danger'" [dismissible]="false">
        <strong>Server Error</strong> {{errorMsg}}
      </ngb-alert>
      <ng-container *ngIf="processing">
        <section>
          <div class="cloud-icon mb-4">
          </div>
          <p class="text-center">Hang on! We're logging you to greytHR </p>
        </section>
      </ng-container>
    </div>
  </section>
</div>
